import { render, staticRenderFns } from "./pre_base_table_3.vue?vue&type=template&id=674d60be&scoped=true"
import script from "./pre_base_table_3.vue?vue&type=script&lang=js"
export * from "./pre_base_table_3.vue?vue&type=script&lang=js"
import style0 from "./pre_base_table_3.vue?vue&type=style&index=0&id=674d60be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d60be",
  null
  
)

export default component.exports